import React, { Component } from "react";
import { Form, Input } from "antd";
import { observer } from "mobx-react";
import styles from "../index.module.less";

const FormItem = Form.Item;

@observer
class SpinnerComBr extends Component {
	render() {
		return (
			<Form layout="vertical" className={styles.rxform}>
				<FormItem label="API Key">
					{this.props.form.getFieldDecorator("spinnerComBr.apiKey")(
						<Input type="text" />
					)}
				</FormItem>
			</Form>
		);
	}
}

export default SpinnerComBr;
